var drawerCollection = document.querySelector('.menu-drawer__slider');

if (drawerCollection) {
  const swiper = new Swiper('.menu-drawer__slider', {
    slidesPerView: 3.5,
    spaceBetween: 10,
  });
}

var pdpRelatedDesigns = document.querySelector('.related-designs-swiper');

if (pdpRelatedDesigns) {
  const swiper = new Swiper(pdpRelatedDesigns, {
    slidesPerView: 4.5,
    spaceBetween: 10,
    pagination: {
      el: '.related-design-pagination',
      type: "bullets",
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3.5,
        spaceBetween: 10,
      },
      1100: {
        slidesPerView: 4.5,
        spaceBetween: 10,
      }
    }
  });
}

// Device selector is now directly connected to the form via form attribute
// No need for additional JavaScript to sync values

document.addEventListener('DOMContentLoaded', function() {
  const handleMobileProductInfo = () => {
    const mobileInfoContainer = document.querySelector('.product-grid__mobile-info');
    const productRating = document.querySelector('.product__rating');
    const productTitle = document.querySelector('.product__title');
    const productPrice = document.querySelector('.product__price');

    if (!mobileInfoContainer) return;

    if (window.innerWidth < 750) {
      if (productRating) {
        const ratingClone = productRating.cloneNode(true);
        mobileInfoContainer.appendChild(ratingClone);
        productRating.style.display = 'none';
      }

      if (productTitle) {
        const titleClone = productTitle.cloneNode(true);
        mobileInfoContainer.appendChild(titleClone);
        productTitle.style.display = 'none';
      }

      if (productPrice) {
        const priceClone = productPrice.cloneNode(true);
        mobileInfoContainer.appendChild(priceClone);
        productPrice.style.display = 'none';
      }
    } else {
      // Reset elements when screen width is >= 750px
      mobileInfoContainer.innerHTML = '';
      if (productRating) productRating.style.display = '';
      if (productTitle) productTitle.style.display = '';
      if (productPrice) productPrice.style.display = '';
    }
  };

  handleMobileProductInfo();

  window.addEventListener('resize', function() {
    handleMobileProductInfo();
  });
});

// Device selector required - disable buttons until device is selected
document.addEventListener("DOMContentLoaded", function () {
    const isIPhoneProductPage = () => {
        if (document.body.classList.contains('template--iphone')) {
            return true;
        }

        const mainProduct = document.querySelector('[data-main-product][data-template-suffix]');
        if (mainProduct && mainProduct.dataset.templateSuffix) {
            return mainProduct.dataset.templateSuffix.toLowerCase() === 'iphone';
        }

        return false;
    };

    if (!isIPhoneProductPage()) {
        // iPhone olmayan ürünlerde cihaz seçimi zorunluluğu uygulanmamalı.
        document.querySelectorAll('.product-form__submit').forEach(button => {
            button.removeAttribute('data-device-required');
            button.style.opacity = '';
            button.style.cursor = '';
        });
        document.querySelectorAll('.shopify-payment-button').forEach(button => {
            button.style.display = '';
        });
        return;
    }

    function checkDeviceSelection() {
        // Check both device selector and variant dropdown
        const deviceSelector = document.getElementById("CustomDeviceSelect") ||
                              document.querySelector('[id^="DeviceSelect-"]');
        const deviceVariantSelect = document.querySelector('select[name*="Cihaz"]');

        let isDeviceSelected = false;

        // Check device selector (properties)
        if (deviceSelector && deviceSelector.value && deviceSelector.value !== "") {
            isDeviceSelected = true;
        }

        // Check variant dropdown (options)
        if (deviceVariantSelect && deviceVariantSelect.value && deviceVariantSelect.value !== "") {
            isDeviceSelected = true;
        }

        // Get all submit buttons
        const submitButtons = document.querySelectorAll('.product-form__submit');
        const dynamicCheckoutButtons = document.querySelectorAll('.shopify-payment-button');

        // Instead of disabling, add a data attribute and style
        submitButtons.forEach(button => {
            if (!isDeviceSelected) {
                // Remove disabled attribute but add data attribute to track state
                button.removeAttribute('disabled');
                button.setAttribute('data-device-required', 'true');
                button.style.opacity = '0.5';
                button.style.cursor = 'not-allowed';
            } else {
                button.removeAttribute('data-device-required');
                button.style.opacity = '';
                button.style.cursor = '';
            }
        });

        // Hide/show dynamic checkout buttons
        dynamicCheckoutButtons.forEach(button => {
            if (!isDeviceSelected) {
                button.style.display = 'none';
            } else {
                button.style.display = '';
            }
        });
    }

    function showDeviceRequiredError() {
        console.log('showDeviceRequiredError called');

        // Find device selector containers - try multiple selectors
        const deviceSelectorContainer = document.querySelector('.product-device-selector');
        const deviceVariantDropdown = document.querySelector('.dropdown__button[data-option-name="Cihaz"]');

        console.log('deviceSelectorContainer:', deviceSelectorContainer);
        console.log('deviceVariantDropdown:', deviceVariantDropdown);

        // Add error class to device selector (properties)
        if (deviceSelectorContainer) {
            deviceSelectorContainer.classList.add('field--error');

            const label = deviceSelectorContainer.querySelector('.field__label');
            if (label) {
                label.classList.add('label--error');
                label.style.color = '#ff0000';
                label.style.fontWeight = 'bold';
                console.log('Label styled');
            }

            const selectInput = deviceSelectorContainer.querySelector('.field__input');
            if (selectInput) {
                selectInput.style.borderColor = '#ff0000';
                selectInput.style.borderWidth = '1px';
                selectInput.style.borderStyle = 'solid';
                selectInput.focus();
                console.log('Select input styled');
            }

            const selectWrapper = deviceSelectorContainer.querySelector('.select-input__wrapper');
            if (selectWrapper) {
                selectWrapper.style.borderColor = '#ff0000';
                selectWrapper.style.borderWidth = '1px';
                selectWrapper.style.borderStyle = 'solid';
                selectWrapper.style.outline = '1px solid #ff0000';
                console.log('Select wrapper styled');
            }

            deviceSelectorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // Add error class to variant dropdown (options)
        if (deviceVariantDropdown && !deviceSelectorContainer) {
            const dropdown = deviceVariantDropdown.closest('.dropdown');
            if (dropdown) {
                dropdown.classList.add('dropdown--error');
            }

            deviceVariantDropdown.style.borderColor = '#ff0000';
            deviceVariantDropdown.style.borderWidth = '1px';
            deviceVariantDropdown.style.borderStyle = 'solid';
            deviceVariantDropdown.style.outline = '1px solid #ff0000';

            const label = deviceVariantDropdown.closest('.product-form__input')?.querySelector('.form__label');
            if (label) {
                label.style.color = '#ff0000';
                label.style.fontWeight = 'bold';
            }

            deviceVariantDropdown.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function removeDeviceRequiredError() {
        // Remove error classes
        const deviceSelectorContainer = document.querySelector('.product-device-selector');
        const deviceVariantDropdown = document.querySelector('.dropdown__button[data-option-name="Cihaz"]');

        if (deviceSelectorContainer) {
            deviceSelectorContainer.classList.remove('field--error');
            const label = deviceSelectorContainer.querySelector('.field__label');
            if (label) {
                label.classList.remove('label--error');
                label.style.color = '';
            }
            const selectInput = deviceSelectorContainer.querySelector('.field__input');
            if (selectInput) {
                selectInput.style.borderColor = '';
            }
        }

        if (deviceVariantDropdown) {
            const dropdown = deviceVariantDropdown.closest('.dropdown');
            if (dropdown) {
                dropdown.classList.remove('dropdown--error');
            }
            deviceVariantDropdown.style.borderColor = '';
            deviceVariantDropdown.style.outline = '';
            const label = deviceVariantDropdown.closest('.product-form__input')?.querySelector('.form__label');
            if (label) {
                label.style.color = '';
            }
        }
    }

    // Initial check
    checkDeviceSelection();

    // Listen for changes on device selector
    const deviceSelector = document.getElementById("CustomDeviceSelect") ||
                          document.querySelector('[id^="DeviceSelect-"]');
    if (deviceSelector) {
        deviceSelector.addEventListener('change', function() {
            checkDeviceSelection();
            removeDeviceRequiredError();
        });
    }

    // Listen for changes on variant dropdown
    const deviceVariantSelect = document.querySelector('select[name*="Cihaz"]');
    if (deviceVariantSelect) {
        deviceVariantSelect.addEventListener('change', function() {
            checkDeviceSelection();
            removeDeviceRequiredError();
        });
    }

    // Listen for dropdown button clicks (custom dropdown)
    const dropdownButtons = document.querySelectorAll('.dropdown__item-button');
    dropdownButtons.forEach(button => {
        button.addEventListener('click', function() {
            setTimeout(function() {
                checkDeviceSelection();
                removeDeviceRequiredError();
            }, 100);
        });
    });

    // Listen for submit button clicks to show error
    const submitButtons = document.querySelectorAll('.product-form__submit');
    console.log('Found submit buttons:', submitButtons.length);

    submitButtons.forEach(button => {
        // Use capture phase to ensure our handler runs first
        button.addEventListener('click', function(e) {
            console.log('Submit button clicked - capture phase');

            // Check if device is required
            if (button.getAttribute('data-device-required') === 'true') {
                console.log('Device required but not selected');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                showDeviceRequiredError();
                return false;
            }
        }, true); // Use capture phase
    });

    // Also listen on the form submit event
    const productForms = document.querySelectorAll('product-form form, form[action*="/cart/add"]');
    console.log('Found product forms:', productForms.length);

    productForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            console.log('Form submit event triggered');

            const deviceSelector = document.getElementById("CustomDeviceSelect") ||
                                  document.querySelector('[id^="DeviceSelect-"]');
            const deviceVariantSelect = document.querySelector('select[name*="Cihaz"]');

            let isDeviceSelected = false;

            if (deviceSelector && deviceSelector.value && deviceSelector.value !== "") {
                isDeviceSelected = true;
            }

            if (deviceVariantSelect && deviceVariantSelect.value && deviceVariantSelect.value !== "") {
                isDeviceSelected = true;
            }

            console.log('Form submit - isDeviceSelected:', isDeviceSelected);

            if (!isDeviceSelected) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                console.log('Form submit prevented - showing error');
                showDeviceRequiredError();
                return false;
            }
        }, true); // Use capture phase
    });

    document.querySelectorAll(".menu-link-group a").forEach(link => {
        link.addEventListener("click", function (event) {
            const model = this.getAttribute("data-model");
            if (model) {
                localStorage.setItem("device-model", model);
            }
        });
    });

    const savedModel = localStorage.getItem("device-model");
    if (savedModel) {
        updateSelectBox(savedModel);
    }

    function updateSelectBox(model) {
        // Support both old CustomDeviceSelect and new DeviceSelect-{section.id} pattern
        const selectBox = document.getElementById("CustomDeviceSelect") ||
                         document.querySelector('[id^="DeviceSelect-"]');
        if (selectBox) {
            const optionToSelect = selectBox.querySelector(`option[value="${model}"]`);
            if (optionToSelect) {
                selectBox.value = model;
                checkDeviceSelection();
            }
        }
        const deviceVariant = document.querySelector('.dropdown__button[data-option-name="Cihaz"]');
        if(deviceVariant) {
          var deviceVariantButtons = document.querySelectorAll('.dropdown__item-button');
          deviceVariantButtons.forEach(button => {
            if(button.textContent === model) {
              button.click();
              setTimeout(checkDeviceSelection, 100);
            }
          });
        }
    }
});
